<template>
  <span :class="[bgClasses, textClasses]" class="rounded py-1 px-2 text-2xs">
    <slot />
  </span>
</template>

<script setup>
const BG_CLASS_MAP = {
  danger: 'bg-danger-700',
  green: 'bg-success-700',
  info: 'bg-secondary-100',
  neutral: 'bg-neutral-100',
  primary: 'bg-primary-100',
  secondary: 'bg-secondary-100',
  success: 'bg-success-100',
  warning: 'bg-warning-100',
};

const TEXT_CLASS_MAP = {
  danger: 'text-neutral-white',
  green: 'text-neutral-white',
  info: 'text-secondary-700',
  neutral: 'text-neutral-700',
  primary: 'text-primary-700',
  secondary: 'text-secondary-700',
  success: 'text-success-700',
  warning: 'text-warning-700',
};

const props = defineProps({
  variant: {
    default: 'primary',
    type: String,
  },
});

const bgClasses = computed(() => {
  return BG_CLASS_MAP[props.variant];
});

const textClasses = computed(() => {
  return TEXT_CLASS_MAP[props.variant];
});
</script>
